import type { CityConfig } from "../city-template/types";

export const wheatRidgeConfig: CityConfig = {
  city: "Wheat Ridge",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "wheat-ridge",
  route: "/cities/wheat-ridge",
  title: "Emergency & Expedited Passport Wheat Ridge CO | Same-Day Jefferson County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Wheat Ridge, Colorado — as fast as 24 hours. Same-day courier processing for Wheat Ridge, Arvada, Lakewood, Golden, Edgewater, and all Jefferson County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Wheat Ridge, CO",
  heroSubtitle: "Last-minute trip to Europe and your passport just expired? Weekend in Vancouver and you can't find your passport? We help Wheat Ridge residents — from historic Wheat Ridge neighborhood families to Clear Creek trail enthusiasts to Jefferson County professionals — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wheat%20Ridge%20Colorado%20suburban%20landscape%20with%20the%20Rocky%20Mountains%20foothills%20in%20the%20distance%2C%20the%20Clear%20Creek%20trail%20winding%20through%20greenbelts%20and%20open%20space%2C%20historic%20mid-century%20homes%20with%20mature%20shade%20trees%20and%20well%20kept%20gardens%20along%20quiet%20residential%20streets%2C%20the%20Wadsworth%20Boulevard%20corridor%20with%20local%20businesses%2C%20golden%20Colorado%20sunset%20light%20casting%20warm%20tones%20across%20the%20landscape%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20natural%20suburban%20prairie%20tones&width=1800&height=700&seq=wheatridge-hero-001&orientation=landscape",
  heroImageAlt: "Wheat Ridge Colorado with Clear Creek greenbelt and Rocky Mountain foothills views",
  geoPosition: "39.7661;-105.0772",
  geoPlacename: "Wheat Ridge, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S. Vaughn Way, Aurora, CO 80014",
    distance: "Approximately 25 miles southeast via I-70 and I-225 — about 30–40 minutes",
  },
  nearbyCitiesZips: [
    { name: "Wheat Ridge", zips: "80033, 80034" },
    { name: "Arvada", zips: "80002, 80003, 80004, 80005" },
    { name: "Lakewood", zips: "80214, 80215, 80226, 80227, 80228" },
    { name: "Golden", zips: "80401, 80403" },
    { name: "Edgewater", zips: "80214" },
    { name: "Denver", zips: "80212, 80211, 80204" },
    { name: "Westminster", zips: "80031, 80030, 80021" },
    { name: "Applewood", zips: "80401" },
    { name: "Mountain View", zips: "80212" },
    { name: "Lakeside", zips: "80212" },
    { name: "Fairmount", zips: "80403" },
    { name: "East Pleasant View", zips: "80401" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Wheat Ridge international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the drive to Aurora, we handle it" },
    { icon: "ri-flight-takeoff-line", title: "I-70 Corridor Access", desc: "Direct I-70 access to Denver International Airport and the mountains" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Wheat Ridge, Arvada, or Lakewood" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Arvada, CO", route: "/cities/arvada" },
    { name: "Fast passport renewal in Wheat Ridge area", route: "/cities/wheat-ridge" },
    { name: "Urgent passport services for Lakewood and Golden", route: "/cities/lakewood-co" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Westminster and Northglenn", route: "/cities/westminster-co" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wheat Ridge remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Wheat Ridge's prime central location — bordered by I-70 to the south and minutes from downtown Denver — makes our courier service especially efficient. Skip the drive through metro traffic on I-70 and I-225 and let us handle everything.",
  fpcOfficeAddress: "3151 S. Vaughn Way, Aurora, CO 80014",
  fpcOfficeDistance: "Serving all of Wheat Ridge, Edgewater, and the western I-70 corridor communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Wheat Ridge and the surrounding western metro area. From the historic Wheat Ridge neighborhoods along 38th Avenue to the communities near Anderson Park and Crown Hill, from the Clear Creek Trail corridor to the Wadsworth Boulevard business district — we serve every corner of Wheat Ridge and the surrounding communities.",
  nearbyCitiesIntro: "We serve Wheat Ridge and all nearby communities including Arvada, Lakewood, Golden, Edgewater, Mountain View, Lakeside, Applewood, Fairmount, and the western Denver neighborhoods.",
  howItWorksIntro: "Most Wheat Ridge travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to drive I-70 through downtown Denver to get to Aurora.",
  mistakesIntro: "Wheat Ridge is a well-established inner-ring suburb with families, outdoor enthusiasts, and professionals who love being close to both the mountains and downtown Denver. Here are the most common passport mistakes we see from Wheat Ridge-area travelers.",
  testimonialsIntro: "Wheat Ridge travelers — from historic neighborhood families to Clear Creek cyclists to Jefferson County professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Wheat Ridge, CO? Here are the most common ones we hear from Jefferson County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (30–40 minutes each way)", "I-70 through downtown Denver is unpredictable"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Wheat Ridge", "Perfect for family vacations and outdoor adventure travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Wheat Ridge travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest service available without fighting I-70 traffic through Denver.",
      bullets: ["24–48 hour turnaround available", "DIA (DEN) departure support via I-70", "Outdoor adventure and family travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Wheat Ridge adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Wheat Ridge address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Wheat Ridge residents and Jefferson County families — including young adults and new citizens.",
      bullets: ["Acceptance facility scheduling in Wheat Ridge or Arvada", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Wheat Ridge residents who lost their passport before international travel — business or vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Wheat Ridge and Jefferson County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Wheat Ridge and Jefferson County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Wheat Ridge CO", description: "Urgent passport processing for Wheat Ridge Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Wheat Ridge CO", description: "Fast passport renewal for Wheat Ridge Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Wheat Ridge CO", description: "New passport application services for Wheat Ridge Colorado residents applying for their first passport." },
    { name: "Child Passport Wheat Ridge CO", description: "Minor passport services for Wheat Ridge Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Barbara S.",
      location: "Wheat Ridge, CO — Near Anderson Park",
      rating: 5,
      text: "Trip to Italy to visit family and realized my passport had expired just 8 days before departure. Fast Passport Center got my renewal done in 4 days. Shipped from the UPS Store on Wadsworth. Absolutely saved my trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Dan W.",
      location: "Wheat Ridge, CO — 38th Avenue Corridor",
      rating: 5,
      text: "Last-minute business trip to Singapore. My passport was damaged and I needed a replacement fast. Fast Passport Center handled it in 3 days. Didn't have to drive anywhere near I-70 rush hour traffic.",
      service: "Emergency Passport Replacement",
    },
    {
      name: "Rachel K.",
      location: "Wheat Ridge, CO — Clear Creek Neighborhood",
      rating: 5,
      text: "Family trip to Costa Rica — three passports including our toddler's first one. Fast Passport Center walked us through the whole DS-11 process and got all three in 6 days. Way easier than trying to coordinate post office appointments.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tom F.",
      location: "Edgewater, CO",
      rating: 5,
      text: "Needed an emergency passport for a funeral in Ireland. Fast Passport Center handled everything with compassion and speed — had my passport in 48 hours. Being so close to Wheat Ridge made the whole process seamless.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "wr-1",
      name: "Wheat Ridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3695 Kipling St",
      city: "Wheat Ridge",
      state: "CO",
      zip: "80033",
      phone: "(303) 422-2200",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Wheat Ridge, near Kipling Street and 38th Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Wheat Ridge acceptance facility. Appointments recommended — call ahead. Serves Wheat Ridge and Edgewater residents. Convenient Kipling Street location.",
      icon: "ri-mail-line",
    },
    {
      id: "wr-2",
      name: "Arvada Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5885 Allison St",
      city: "Arvada",
      state: "CO",
      zip: "80004",
      phone: "(303) 422-6511",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 3 miles north of Wheat Ridge, in Arvada",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment availability. Good alternative when Wheat Ridge appointments are full. Near Olde Town Arvada.",
      icon: "ri-mail-line",
    },
    {
      id: "wr-3",
      name: "Lakewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10799 W Alameda Ave",
      city: "Lakewood",
      state: "CO",
      zip: "80226",
      phone: "(303) 985-8438",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 5 miles south of Wheat Ridge, in Lakewood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Extended hours (open until 5PM) at a larger facility. Good option for evening passport appointments after work. Serves the western metro corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "wr-4",
      name: "Golden Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "619 12th St",
      city: "Golden",
      state: "CO",
      zip: "80401",
      phone: "(303) 279-9769",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 8 miles west of Wheat Ridge, in Golden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western acceptance facility for Wheat Ridge-Golden corridor residents. Historic downtown Golden location. Good for foothills communities.",
      icon: "ri-mail-line",
    },
    {
      id: "wr-5",
      name: "Jefferson County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "100 Jefferson County Pkwy",
      city: "Golden",
      state: "CO",
      zip: "80419",
      phone: "(303) 271-8185",
      hours: "Mon–Fri: 7:30 AM – 5:00 PM",
      distance: "Approximately 8 miles west of Wheat Ridge, in Golden",
      website: "https://www.jeffco.us/",
      websiteLabel: "Jefferson County Clerk",
      notes: "County government passport acceptance at the Jefferson County Administration Building. Extended hours including early morning (7:30AM start). Serves all Jefferson County residents.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25-mile drive to Aurora via I-70/I-225", fpc: "No — ship from Wheat Ridge" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-70 Downtown Corridor", agency: "Heavy traffic through downtown Denver", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Summer or Winter Break",
      description: "Wheat Ridge families often wait until school breaks to check passports. Routine processing takes 8–11 weeks during peak seasons. Start expedited service at least 4 weeks before travel — especially June through August and November through January.",
    },
    {
      icon: "ri-image-line",
      title: "Relying on Drugstore Photo Booths",
      description: "Automated photo booths at Wheat Ridge pharmacies and grocery stores don't always produce compliant passport photos. Head positioning, shadows, and background issues are common. Get photos taken by a trained staff member who knows passport requirements.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Comparing Facility Hours and Availability",
      description: "Wheat Ridge Post Office has standard 9–4:30 hours. The Jefferson County Clerk in Golden opens at 7:30AM and closes at 5PM — much more flexible for working professionals. Lakewood Post Office also stays open until 5PM.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating I-70 Corridor Traffic",
      description: "I-70 through downtown Denver is one of the most congested highways in Colorado. Driving from Wheat Ridge to the Aurora passport agency during rush hour can easily take 45–60 minutes. Our courier service eliminates this entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Passport Validity Before Booking",
      description: "Many Jefferson County outdoor enthusiasts book international adventure trips to Patagonia, the Alps, or Nepal without first checking passport expiration dates. Always verify your passport validity before making non-refundable bookings.",
    },
    {
      icon: "ri-road-map-line",
      title: "Confusing Wheat Ridge Post Office with Nearby Facilities",
      description: "Wheat Ridge is surrounded by multiple cities (Arvada, Lakewood, Edgewater) with their own post offices. Make sure you go to the right facility with the right appointment — the Wheat Ridge Post Office is specifically at 3695 Kipling Street.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Wheat Ridge or Jefferson County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Wheat Ridge, Arvada, or Lakewood." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Jefferson County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-70 downtown Denver traffic battle." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wheat Ridge address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Wheat Ridge, CO?", a: "Fast Passport Center offers emergency passport processing in Wheat Ridge, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to drive I-70 through downtown Denver to the Aurora passport agency." },
    { q: "Does Wheat Ridge have its own passport agency?", a: "No — Wheat Ridge does not have a regional passport agency. The nearest is the Denver Passport Agency in Aurora (25 miles southeast via I-70 and I-225). Fast Passport Center's courier service means Wheat Ridge residents never need to deal with I-70 downtown traffic." },
    { q: "What's the best acceptance facility near Wheat Ridge?", a: "The Wheat Ridge Post Office (3695 Kipling St) is the most convenient. For more flexible hours, the Jefferson County Clerk in Golden (opens 7:30AM) and the Lakewood Post Office (open until 5PM) are excellent alternatives. Arvada Post Office (3 miles north) also has good availability." },
    { q: "What if I live in Edgewater, Mountain View, or Lakeside?", a: "Absolutely. Fast Passport Center serves all of Wheat Ridge and the surrounding small communities including Edgewater, Mountain View, and Lakeside. Our service works the same way everywhere — ship your documents and we handle the rest from anywhere in the Wheat Ridge area." },
    { q: "Can you help with passports for outdoor adventure travelers?", a: "Yes. Fast Passport Center serves Wheat Ridge's active outdoor community — from mountain bikers heading to Whistler to hikers trekking the Alps to skiers traveling internationally. We understand the needs of adventure travelers with tight seasonal schedules." },
    { q: "How much does an expedited passport cost in Wheat Ridge, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Wheat Ridge?", a: "Walgreens (3800 Kipling St) and King Soopers (3400 Youngfield St) offer passport photo services in Wheat Ridge. UPS Store and FedEx Office locations in nearby Arvada and Lakewood also provide photos. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the entire Wheat Ridge-Lakewood-Golden corridor?", a: "Yes. Fast Passport Center serves the full western metro corridor including Wheat Ridge, Lakewood, Golden, Arvada, Edgewater, Applewood, and all surrounding Jefferson County communities. Our courier service covers the complete I-70 west corridor from downtown Denver to the foothills." },
  ],
  photoLocations: [
    { name: "Walgreens — Wheat Ridge", address: "3800 Kipling St, Wheat Ridge, CO 80033", hours: "Mon–Sun: 8AM–9PM" },
    { name: "King Soopers — Wheat Ridge", address: "3400 Youngfield St, Wheat Ridge, CO 80033", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Arvada", address: "7720 Wadsworth Blvd, Arvada, CO 80003", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "FedEx Office — Lakewood", address: "98 Wadsworth Blvd, Lakewood, CO 80226", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "DMV — Wheat Ridge (Jefferson County)", address: "2099 Wadsworth Blvd, Lakewood, CO 80214", hours: "Mon–Fri: 8AM–5PM", note: "Jefferson County DMV at the Wadsworth Boulevard location — serving Wheat Ridge and Lakewood residents. REAL ID and driver's license renewals. Conveniently located at the Wheat Ridge-Lakewood border.", featured: true },
    { name: "DMV — Arvada (Jefferson County)", address: "6510 Wadsworth Blvd, Arvada, CO 80003", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV in Arvada for northern Wheat Ridge residents. REAL ID processing available. Convenient Wadsworth Boulevard access.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "30 miles east via I-70 and Peña Blvd — approximately 35–40 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Direct access from Wheat Ridge via I-70 east.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BJC",
      name: "Rocky Mountain Metropolitan Airport",
      distance: "15 miles north via Wadsworth — approximately 20–25 minutes",
      address: "11755 Airport Way, Broomfield, CO 80021",
      note: "General aviation and corporate airport serving the northern metro area. No scheduled commercial service. Private and charter flights only. Convenient for Wheat Ridge via Wadsworth Boulevard north.",
      flightUrl: "https://www.flyrmm.com/",
      flightLabel: "BJC Flight Info",
      featured: false,
    },
  ],
};